import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

const googleapis = window.lt.api.googleapis as ltFramework.IDictionary;
let optionsInitialized = false;

export const useMapsLoader = () => {
	if (!optionsInitialized) {
		setOptions({
			channel: 'aem-web',
			key: googleapis?.key ?? '',
			libraries: ['maps', 'marker', 'geocoding', 'places']
		});
		optionsInitialized = true;
	}
	return {
		importLibrary
	};
};
